import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=3f2a5b89&"
import script from "./Rules.vue?vue&type=script&lang=ts&"
export * from "./Rules.vue?vue&type=script&lang=ts&"
import style0 from "./Rules.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports